export default __webpack_public_path__ + "static/media/simProfile-5.ece63ec6.png";